// extracted by mini-css-extract-plugin
export default {"slotDiv":"SlotEditorModal_slotDiv__X5oto","slotLeftDiv":"SlotEditorModal_slotLeftDiv__4-lFZ"};